import { render } from "./ProjectsView.vue?vue&type=template&id=9dad2124&scoped=true"
import script from "./ProjectsView.vue?vue&type=script&lang=js"
export * from "./ProjectsView.vue?vue&type=script&lang=js"

import "./ProjectsView.vue?vue&type=style&index=0&id=9dad2124&scoped=true&lang=css"

import exportComponent from "/Users/peterdevos/Sites/sephendevos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dad2124"]])

export default __exports__